import { paths } from '@/constants/paths'

export interface BuildLoginUrlOptions {
  returnTo: string
  email?: string
}

export const buildLoginUrl = (returnToOrOptions: string | BuildLoginUrlOptions): string => {
  const options: BuildLoginUrlOptions =
    typeof returnToOrOptions === 'string' ? { returnTo: returnToOrOptions } : returnToOrOptions

  const hashed = Buffer.from(options.returnTo, 'utf-8').toString('base64')
  const params = new URLSearchParams()
  params.set('returnTo', hashed)

  if (options.email) {
    params.set('email', options.email)
  }

  // Use manual string building to avoid double-encoding of the already-encoded base64 returnTo
  const paramString = Array.from(params.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `${paths.auth.login}?${paramString}`
}

export const buildLogoutUrl = (returnTo?: string): string => {
  if (returnTo) {
    const hashed = Buffer.from(returnTo, 'utf-8').toString('base64')
    return `${paths.auth.logout}?returnTo=${hashed}`
  } else {
    return paths.auth.logout
  }
}
